// Obtain Server Info from PRCY Team
const PRODUCTION_SERVER = "https://api.prcycoin.com";
const DEV_SERVER = "";
const TX_SERVER = "https://api.prcycoin.com";
console.log('wallet env:', process.env.NODE_ENV)
const config = {
    // Choose mainnet or testnet - testnet currently not supported.
    PRCYCHAIN: "mainnet",
    // Obtain SERVER_ENCRYPTION_KEY from PRCY Team
    SERVER_ENCRYPTION_KEY: "07fd9e683c44931d2c14d66774052545957c0c5dee22e2e7e1af2f54033fad1c02",
    // Choose whether you are using Production or Dev servers
    PRCY_SERVER: process.env.NODE_ENV == 'DEV' ? DEV_SERVER : PRODUCTION_SERVER,
    // Set the transaction server to handle transaction broadcasts
    PRCY_TX_SERVER: process.env.NODE_ENV == 'DEV' ? DEV_SERVER : TX_SERVER,
    // CoinGecko Price API Link (USD)
    PRICE_COINGECKO: "https://api.coingecko.com/api/v3/simple/price?ids=prcy-coin&vs_currencies=USD&include_market_cap=false&include_24hr_vol=false&include_24hr_change=true&include_last_updated_at=false",
    // Whether or not to lock masternode collaterals during transaction sends - default true to avoid breaking Masternodes
    LOCK_COLLATERAL: false,
    // Enable Debugging
    ENABLE_DEBUG: false,
    // Enable the Rewards Counter in console log
    ENABLE_REWARDS_COUNTER: false,
    // reCAPTCHA key from https://developers.google.com/recaptcha/docs/verify
    CAPTCHA_KEY: "a32953bf-ee49-46f7-9329-799a6891f475",
}
module.exports = config;
